import { c as _c } from "react/compiler-runtime";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "cn";
import type * as React from "react";
const formLabelVariants = cva(["flex items-center gap-1 select-none", "text-foreground", "peer-disabled:cursor-not-allowed peer-disabled:opacity-50", "group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50"], {
  variants: {
    size: {
      large: "label-lg",
      medium: "label-md",
      small: "label-sm"
    }
  },
  defaultVariants: {
    size: "medium"
  }
});
interface FormLabelProps extends React.ComponentProps<typeof LabelPrimitive.Root>, VariantProps<typeof formLabelVariants> {}
function FormLabel(t0) {
  const $ = _c(10);
  let className;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      className,
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
  }
  let t1;
  if ($[4] !== className || $[5] !== size) {
    t1 = cn(formLabelVariants({
      size,
      className
    }));
    $[4] = className;
    $[5] = size;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== t1) {
    t2 = <LabelPrimitive.Root data-slot="form-label" className={t1} {...props} />;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export { FormLabel, formLabelVariants, type FormLabelProps };